<template>
  <div class="brc">
    <b-form-input
      :id="id"
      v-model="first"
      :disabled="disabled"
      type="text"
      maxlength="8"
      @keyup="handleAutoNextFocus($event, 8)"
      @keydown.space.prevent
    ></b-form-input>
    <span>-</span>
    <b-form-input
      v-model="second"
      :disabled="disabled"
      type="text"
      maxlength="3"
      @keyup="handleAutoNextFocus($event, 3)"
      @keydown.space.prevent
    ></b-form-input>
    <span>-</span>
    <b-form-input
      v-model="third"
      :disabled="disabled"
      type="text"
      maxlength="2"
      @keyup="handleAutoNextFocus($event, 2)"
      @keydown.space.prevent
    ></b-form-input>
    <span>-</span>
    <b-form-input
      v-model="fourth"
      :disabled="disabled"
      type="text"
      maxlength="2"
      @keyup="handleAutoNextFocus($event, 2)"
      @keydown.space.prevent
    ></b-form-input>
    <span>-</span>
    <b-form-input
      v-model="fifth"
      :disabled="disabled"
      type="text"
      maxlength="1"
      @keyup="handleAutoNextFocus($event, 1)"
      @keydown.space.prevent
    ></b-form-input>
  </div>
</template>

<script>
import { merge } from 'rxjs';
import { tap, startWith } from 'rxjs/operators';
import { BFormInput } from 'bootstrap-vue';

export default {
  components: {
    BFormInput,
  },
  props: {
    disabled: Boolean,
    label: String,
    id: String,
    value: [String, Number],
  },
  data: () => ({
    inputVal: null,
    first: '',
    second: '',
    third: '',
    fourth: '',
    fifth: '',
  }),
  methods: {
    handleAutoNextFocus({ keyCode, target }, length) {
      // only when the key is not arrow key and it is not whitespace
      if (keyCode !== 32 && (keyCode < 37 || keyCode > 40)) {
        if (target.value.length === length) {
          if (target.nextElementSibling?.nextElementSibling) {
            target.nextElementSibling.nextElementSibling.focus();
          } else target.blur();
        }
      }
    },
  },
  watch: {
    inputVal(val) {
      this.$emit('input', val);
    },
  },
  subscriptions() {
    return {
      value$: this.$watchAsObservable('value').pipe(
        startWith(1),
        tap(() => {
          if (this.value) {
            const brcNumberString = this.value.toString();
            if (!this.inputVal || this.inputVal !== brcNumberString) {
              this.first = brcNumberString.slice(0, 8);
              this.second = brcNumberString.slice(8, 11);
              this.third = brcNumberString.slice(11, 13);
              this.fourth = brcNumberString.slice(13, 15);
              this.fifth = brcNumberString.slice(15);
            }
          }
        }),
      ),
      brcNumber$: merge(
        this.$watchAsObservable('first'),
        this.$watchAsObservable('second'),
        this.$watchAsObservable('third'),
        this.$watchAsObservable('fourth'),
        this.$watchAsObservable('fifth'),
      ).pipe(
        tap(() => {
          this.inputVal = `${this.first}${this.second}${this.third}${this.fourth}${this.fifth}`;
        }),
      ),
    };
  },
};
</script>

<style lang="scss" scoped>
.brc {
  input {
    display: inline-block;
    text-align: center;
    padding: 3px;

    &:nth-child(1) {
      width: 5rem;
    }
    &:nth-child(3) {
      width: 3rem;
    }
    &:nth-child(5) {
      width: 2rem;
    }
    &:nth-child(7) {
      width: 2rem;
    }
    &:nth-child(9) {
      width: 1.5rem;
    }

    &:disabled {
      border: none;
      background: none;
    }
  }
}
</style>
